export default {
  warehouse: {
    WarehouseInfo: '仓库信息',
    WarehouseName: '仓库名称',
    WarehouseCode: '仓库编号',
    WarehouseLinkMan: '仓库联系人',
    WarehouseTel: '仓库电话',
    WarehouseAdmin: '仓库管理员',
    ChooseWarehouseAdmin: '选择仓库管理员',
    ChooseWarehouse: '仓库选择',
    Address: '地址',
    Remark: '备注',
    IsDefaultWarehouse: '是否为默认仓库',
    SetAsDefaultWarehouse: '是否设置为默认仓库?',
    SetAsDefault: '设为默认',
    WarehouseNameCanNotBeEmpty: '仓库名称不能为空',
    PleaseEnterCorrectWarehouseName: '请输入正确的仓库名称',
    WarehouseAdminCanNotBeEmpty: '仓库管理员不能为空',
    PleaseEnterCorrectWarehouseAdmin: '请输入正确的管理员',
    AddressCanNotBeEmpty: '地址不能为空',
    AddressMustNotHaveSpaces: '地址不能有空格',
    TelCanNotBeEmpty: '电话不能为空',
    PleaseEnterCorrectTel: '请输入正确的电话号码',
    AddWarehouse: '新增仓库',
    EditWarehouse: '修改仓库信息',
    DeptName: '单位名称',
    Name: '姓名',
    Male: '男',
    Female: '女'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/ims/warehouse.js